<mat-tab-group>

    <mat-tab label="{{'DISPATCH.CREAR_ENCUESTA' | translate}}">
        <vista-gen (cambiaPaso)="cambiaPaso($event)" (dataPiloto)="datosPiloto($event)" (revisarModificaciones)="revisarModificaciones($event)" [actualizaPaso]="actualizaPaso.asObservable()" (actualizaFlagCambios)="actualizaFlagCambios($event)" (seccionesEspeciales)="seccEspHabilitadas = $event"></vista-gen>
    </mat-tab>

    <mat-tab label="{{'DISPATCH.CERTIFICAR2.USERSDEMO' | translate}}" [disabled]="!encuestaCreada">
        <table mat-table *ngIf="usuariosTest" [dataSource]="usuariosTest" class="mat-elevation-z8 tabUsuarios p-20">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> {{'DISPATCH.CERTIFICAR2.USERS' | translate}} </th>
                <td mat-cell *matCellDef="let fila"> {{fila.name}} </td>
            </ng-container>
            <ng-container matColumnDef="weight">
                <td mat-cell *matCellDef="let fila"> {{fila.password}}</td>
                <th mat-header-cell *matHeaderCellDef> {{'DISPATCH.CERTIFICAR2.CLAVE' | translate}}</th>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> {{'DISPATCH.CERTIFICAR2.ESTATUS' | translate}} </th>
                <td mat-cell *matCellDef="let fila" >
                  <h3 *ngIf="!fila.asignado"></h3>
                  <h3 *ngIf="fila.asignado" style="color:red"> {{'DISPATCH.CERTIFICAR2.ESTATUS-USER-ASIGNA' | translate}}</h3>
                </td>
            </ng-container>
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> {{'DISPATCH.BTN_COPY' | translate}} </th>
                <td mat-cell *matCellDef="let fila">
                  <button mat-mini-fab color="primary" aria-label="Example icon button with a menu icon" (click)="copyMessage(fila.password,fila._id)" [disabled]="fila.asignado">
                    <mat-icon>file_copy</mat-icon>
                  </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let fila; columns: displayedColumns;"></tr>
        </table>
    </mat-tab>

    <mat-tab label="{{'DISPATCH.ENCUESTA_DEMO' | translate}}" [disabled]="!encuestaCreada">
        <div fxLayout="column" fxLayoutAlign="center center">
            <h2>{{'DISPATCH.TITULO' | translate}}</h2>
            <mat-card>
                <div fxLayout="row" fxLayoutAlign="start center" *ngIf="urlMenos50!=''">
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.LINKNORMA35' | translate}} {{'DISPATCH.URL35.MENOS50' | translate}}:</h3> &nbsp;
                    <h3 style="font-weight:bold;" > <a href="{{ urlMenos50 }}" target="_blank">{{urlMenos50}}</a></h3>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" *ngIf="urlMas50!=''">
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.LINKNORMA35' | translate}} {{'DISPATCH.URL35.MAS50' | translate}}:</h3> &nbsp;
                    <h3 style="font-weight:bold;" > <a href="{{ urlMas50 }}" target="_blank">{{urlMas50}}</a></h3>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" *ngIf="encuestaCreada">
                    <!--(click)="copyMessage(claveConteos)"-->

                    <button *ngIf="usuariosNoAsignados.length > 0" mat-raised-button class="mb-20" value="click to copy" (click)="copyMessage(usuariosNoAsignados[0].password,usuariosNoAsignados[0]._id)">
                      {{'DISPATCH.BTN_COPY' | translate}} {{usuariosNoAsignados[0].name}}
                      <mat-icon class="ml-20 ">file_copy</mat-icon>
                    </button>
<!--
                    <button mat-raised-button class="ml-20 mb-20" value="click to copy" (click)="urlCodigoQR()">
                      {{'SHEDULE2_0.CARDS.MODALGEN.URL_QR.BOTON' | translate}}
                      <mat-icon class="ml-20 ">qr_code_2</mat-icon>
                    </button> -->


                    <!-- <button style="background-color: #0E35F4; color:white" mat-raised-button color="accent">Customize Shoirt URL<mat-icon>email</mat-icon></button> -->

                </div>
                <mat-divider></mat-divider>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.CERTIFICAR2.CLAVE_ENCUESTA' | translate}}</h3>
                </div>
                <mat-divider></mat-divider>

                <div fxLayout="row" fxLayoutAlign="start center">
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.CERTIFICAR2.INSTRUCCION3' | translate}}</h3>
                </div>
                <mat-divider></mat-divider>

                <div fxLayout="row" fxLayoutAlign="start center">
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.CERTIFICAR2.INSTRUCCION4' | translate}}</h3>
                </div>

                <mat-divider></mat-divider>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.AUTOLOG_35' | translate}}</h3>&nbsp;
                    <h3 style="font-weight:bold;"><a href="{{ urlAutoLogin }}" target="_blank">{{urlAutoLogin}}</a></h3>
                </div>
              <!-- <ng-container *ngIf="validationUser">
                <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!modifUrlShort">
                  <button color="accent" mat-raised-button (click)="openEditarUrlEncuesta()" disabled>{{'DISPATCH.CERTIFICAR2.CUS_SHOI_URL' | translate}}<mat-icon>email</mat-icon></button>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" *ngIf="modifUrlShort">
                  <button style="background-color: #0E35F4; color:white; margin-top:10px" mat-raised-button (click)="openEditarUrlEncuesta()" [disabled]="pasoCompleto">{{'DISPATCH.CERTIFICAR2.CUS_SHOI_URL' | translate}}<mat-icon>email</mat-icon></button>
                </div>

              </ng-container> -->
            </mat-card>
        </div>
    </mat-tab>
</mat-tab-group>

<ng-container *ngIf="changeInfoFin">
  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>

    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearEncuesta()" mat-fab aria-label=""
    matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
    >
    <mat-icon>lock_open</mat-icon>
  </button>

  <button *ngIf="!pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearEncuesta()" mat-raised-button class="reopen mr-20">
    {{'CERTIFICAR.ADICIONALES.STATUS.UNLOCK' | translate}}
    <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
  </button>
</div>

</ng-container>
